export default "./images/survio-2Pm3d-assets-loader.gif";